/**
 * Utility function to fix aria-live attributes for form error messages
 * This can be called on page load to ensure accessibility for error messages
 */
export default function fixAriaLiveForErrors() {
  // Run the fix and also set up a MutationObserver to catch dynamically added errors
  const applyFix = () => {
    const errorItems = document.querySelectorAll('.formulate-input-error');
    errorItems.forEach(item => {
      if (item.getAttribute('aria-live') !== 'assertive') {
        item.setAttribute('aria-live', 'assertive');
      }
    });
  };

  // Apply fix
  applyFix();

  // Set up observer to watch for DOM changes
  const observer = new MutationObserver((mutations) => {
    let shouldApplyFix = false;

    mutations.forEach(mutation => {
      // Check if any added nodes might contain error messages
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        Array.from(mutation.addedNodes).forEach(node => {
          if (node.nodeType === 1) { // Element node
            if (node.classList &&
                (node.classList.contains('formulate-input-error') ||
                 node.querySelector('.formulate-input-error'))) {
              shouldApplyFix = true;
            }
          }
        });
      }
    });

    if (shouldApplyFix) {
      applyFix();
    }
  });

  // Start observing the document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  return {
    applyFix,
    observer
  };
}
